import { IExecutionOptions, IQueryOptions } from '@kurtosys/types/query/index.js';
import { ITransformOptions } from '@kurtosys/types/query/transforms/ITransformOptions.js';

import { BaseTransform } from './BaseTransform.js';

export class FindRowFieldTransform extends BaseTransform {
	// eslint-disable-next-line @typescript-eslint/no-unused-vars, @typescript-eslint/no-empty-function
	execute(queryResponse: any[], queryOptions: IQueryOptions, executionOptions: IExecutionOptions): void {
		let response: any = queryResponse;
		const { findRowFieldTransformOptions } = this.options;

		if (queryResponse) {
			const { conditional, rowIndex, rowPosition, key } = findRowFieldTransformOptions;
			const transforms: ITransformOptions[] = [
				{
					transformOptionsType: 'findRow',
					findRowTransformOptions: {
						conditional: conditional,
						rowIndex: rowIndex,
						rowPosition: rowPosition,
					},
				},
			];
			queryResponse = this.applyTransforms(
				queryResponse,
				transforms,
				{ queryOptionsType: 'none' },
				executionOptions,
			);
			response = queryResponse[key];
		}
		return response;
	}
	applyTransforms = (
		value: any,
		transforms: ITransformOptions[],
		queryOptions: IQueryOptions,
		executionOptions: IExecutionOptions,
	): any => {
		if (transforms) {
			for (const transformOptions of transforms) {
				const transform = new this.dependencies.transformClass(
					this.dependencies,
					transformOptions,
					this.translationHelper,
					this.callStackLevel,
				);
				value = transform.execute(value, queryOptions, { ...executionOptions, responseContext: value });
			}
		}
		return value;
	};
}
